<template>
    <v-navigation-drawer :clipped="$vuetify.breakpoint.lgAndUp" app permanent :value="drawer" :mini-variant.sync="mini">
            <v-list-item v-if="!mini">
                <v-list-item-content>
                <v-list-item-title class="text-h6">
                    Admin Menu
                </v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-divider v-if="!mini"></v-divider>

            <v-list
                dense
                nav
            >
                <Link 
                v-for="item in items"
                :key="item.title"
                :href="item.path">
                <v-list-item
                link
                >
                    <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                    </v-list-item>
                </Link>
                <v-subheader inset>Reports</v-subheader>
                <Link 
                v-for="item in reports"
                :key="item.title + 'report'"
                :href="item.path">
                <v-list-item
                link
                >
                    <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                    </v-list-item>
                </Link>
                <v-subheader inset>Analytics</v-subheader>
<Link 
                v-for="item in analytics"
                :key="item.title"
                :href="item.path">
                <v-list-item
                link
                >
                    <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                    </v-list-item>
                </Link>

            </v-list>
            <v-spacer></v-spacer>
            <div class="pa-2">
                <div class="d-flex">
                <v-spacer></v-spacer>
                <v-icon left v-if="!mini" @click="mini=!mini">
                    mdi-chevron-double-left
                    </v-icon>
                    <v-icon left v-if="mini" @click="mini=!mini">
                    mdi-chevron-double-right
                    </v-icon>
                    </div>
            </div>
            </v-navigation-drawer>
    
</template>

<script>

import { Link } from '@inertiajs/inertia-vue'
    
export default {
  props: {
    source: String,
    drawer: Boolean,
    mini: Boolean,
  },
  components: {
    Link,
  },
  data() {
    return {
        items: [

        { title: 'Jobs', icon: 'mdi-briefcase',path:'/admin/jobs'},
        { title: 'Courses', icon: 'mdi-book-open',path:'/admin/courses'},
        { title: 'Categories', icon: 'mdi-shape',path:'/admin/categories'},
        { title: 'Organizations', icon: 'mdi-domain',path:'/admin/organizations'},
        { title: 'Events', icon: 'mdi-calendar',path:'/admin/events'},
        { title: 'Downloads', icon: 'mdi-download',path:'/admin/downloads'},
        
        { title: 'Users', icon: 'mdi-account',path:'/admin/users'},

        { title: 'Roles', icon: 'mdi-shield-account-variant-outline',path:'/admin/roles'},
        { title: 'Permissions', icon: 'mdi-shield-key-outline',path:'/admin/permissions'},
        
        { title: 'Reports', icon: 'mdi-chart-line',path:'/admin/reports'},

      ],
      reports: [
        { title: 'Jobs', icon: 'mdi-briefcase',path:'/admin/reports/jobs'},
        { title: 'User Jobs', icon: 'mdi-briefcase',path:'/admin/reports/jobs2'},
        { title: 'Filtered Jobs', icon: 'mdi-briefcase',path:'/admin/reports/filteredJobs'},
        { title: 'Courses', icon: 'mdi-book-open',path:'/admin/reports/courses'},
        { title: 'User Courses', icon: 'mdi-book-open',path:'/admin/reports/courses2'},
        { title: 'Users', icon: 'mdi-account',path:'/admin/reports/users'},
        { title: 'Experience', icon: 'mdi-account-hard-hat',path:'/admin/reports/usersByExperience'},
      ],
      analytics: [
        { title: 'Summary', icon: 'mdi-web',path:'/admin/analytics'},
        { title: 'User Jobs', icon: 'mdi-magnify',path:'/admin/analytics/search'},
      ],
    }
  }
}
</script>